/**
 * @template {any[]} TParams
 * @typedef {(password: string, ...args: TParams) => boolean | string} PasswordChecker
 */
export const PasswordChecks = {
  /** @type {PasswordChecker<[number?]>} */
  hasMinimumLength(password, minLength = 8) {
    return password?.length >= minLength || `Minimum of ${minLength} characters`;
  },

  /** @type {PasswordChecker<[string[]?]>} */
  hasSpecial(password, specialCharacters = "@$!%*?&#^()=+{}[];:‘“|,<.>/`~'\"\\-_".split("")) {
    return specialCharacters.some(char => password?.includes(char)) || "Must have at least one special character";
  },

  /** @type {PasswordChecker<[]>} */
  hasUppercase(password) {
    return password?.split("")?.some(char => char.charCodeAt(0) >= 65 && char.charCodeAt(0) <= 90) || "Must have at least one uppercase character";
  },

  /** @type {PasswordChecker<[]>} */
  hasLowercase(password) {
    return password?.split("")?.some(char => char.charCodeAt(0) >= 97 && char.charCodeAt(0) <= 122) || "Must have at least one lowercase character";
  },

  /** @type {PasswordChecker<[]>} */
  hasDigit(password) {
    const digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(d => d.toString());
    return digits.some(d => password.includes(d)) || "Must have at least one digit";
  }

};